import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

/**
 * Returns a description of a dataset aggregation
 * @param {Object} options
 * @param {Dataset} options.dataset
 * @param {String} [options.equation] if specified, indicates an equation that
 * should be returned for the description
 * @param {String} options.aggregationType the aggregation type
 * @param {Object} [options.aggregationField] the field we're aggregating on, or
 * null if we're looking at the total
 * @param {Object} [options.aggregationVisibleLinkedField] the visible linked field
 * @param {Object} [options.calendarField] the field we're breaking down bycommon.select.placeholder
 * calendar, if applicable
 * @param {String} [options.tracked] the value for the dataset's tracked field. Only
 * necessary when looking at a total and the aggregationField is null
 * @returns {String} the description
 */
function fieldAggregationDescription (options) {
	if (options.equation) return options.equation

	let aggregationField = unwrapModel(options.aggregationField)
	let aggregationVisibleLinkedField = options.aggregationVisibleLinkedField
	let calendarField = unwrapModel(options.calendarField)
	let calendarFieldLabel = calendarField ?
		options.dataset.getFieldLabel(calendarField) : ''

	const getUniqueKeySegment = () => {
		switch (options.aggregationType) {
			case 'min-date': return 'minimum.date.in'
			case 'max-date': return 'maximum.date.in'
			case 'min-time': return 'minimum.time.in'
			case 'max-time': return 'maximum.time.in'
			default: return options.aggregationType
		}
	}

	if (aggregationField) {
		let key = 'datasets.total.' + getUniqueKeySegment()
		// this is for when we're displaying a message like "Average {0} by {1}"
		// in a chart or dashboard
		if (calendarField) {
			key += '.byDateField'
		} else if (_.get(aggregationField, 'dataType') === DATE) {
			key += '.date'
		}

		let aggregationFieldLabel = aggregationVisibleLinkedField
			? aggregationVisibleLinkedField.label
			: options.dataset.getFieldLabel(aggregationField)
		return i18n.get(key, aggregationFieldLabel, calendarField ? calendarFieldLabel : '')
	} else { // this must be the total tracked for the native dataset
		if (aggregationVisibleLinkedField) {
			if (calendarField) {
				return i18n.get('datasets.total.byDate',
					options.aggregationVisibleLinkedField.label, calendarFieldLabel)
			} else {
				return options.aggregationVisibleLinkedField.label
			}
		} else {
			let key = 'datasets.total.tracked'
			if (calendarField) {
				key += '.byDateField'
			}
			let tracked = options.tracked

			return i18n.get(key, tracked, calendarField ? calendarFieldLabel : '')
		}
	}
}

export default fieldAggregationDescription

fieldAggregationDescription.__filename__ = 'datasets/field-aggregation-description.js'
